import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { ComumService } from '../../comum/comum.service';
import { AuthService } from '../../auth/auth.service';
import { PermissoesAcessoService } from '../permissoes-acesso.service';
import { UsuarioFuncionalidade } from '../../comum/modelos/usuario-funcionalidade';
import { UsuarioService } from '../../usuario/usuario.service';
import { CookieService } from 'angular2-cookie';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Usuario } from '../../comum/modelos/usuario';

@Component({
  selector: 'app-listar-usuarios-filtro-funcionalidade',
  templateUrl: './listar-usuarios-filtro-funcionalidade.component.html',
  styleUrls: ['./listar-usuarios-filtro-funcionalidade.component.css']
})
export class ListarUsuariosFiltroFuncionalidadeComponent implements OnInit {

  @Output() usuarioFuncionalidadeEvent: EventEmitter<UsuarioFuncionalidade[]>;
  @Input() idFuncionalidade: number;
  @Input() idGrupoAcesso: number;
  usuariosFuncionalidade: UsuarioFuncionalidade[];
  usuarios: Usuario[];

  filtroPesquisaNomeUsuarioBind: string;

  paginacao: Paginacao;

  selecionados: boolean;
  statusCode: number;

  public loading = false;

  constructor(private _comumService: ComumService,
    private _permissoesAcessoService: PermissoesAcessoService,
    private _usuarioService: UsuarioService,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.paginacao = new Paginacao();
    this.usuariosFuncionalidade = new Array<UsuarioFuncionalidade>();
    this.usuarios = new Array<Usuario>();
    this.usuarioFuncionalidadeEvent = new EventEmitter<UsuarioFuncionalidade[]>();
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    const idsGrupoAcesso = new Array<number>();
    idsGrupoAcesso.push();

    forkJoin(this._permissoesAcessoService.obterUsuariosFuncionalidadeHttp(this.idFuncionalidade, this.idGrupoAcesso),
      this._usuarioService.obterUsuariosHttp(parseInt(this._cookieService.get('idCliente'), 10)),
      this._permissoesAcessoService.obterFuncionalidadeHttp(this.idFuncionalidade))
      .subscribe(([usuariosFuncionalidade, usuarios, funcionalidade]) => {
        for (const usuario of usuarios) {
          const novoUsuarioFuncionalidade = new UsuarioFuncionalidade();
          novoUsuarioFuncionalidade.usuario = usuario;
          novoUsuarioFuncionalidade.funcionalidade = funcionalidade;
          novoUsuarioFuncionalidade.idGrupoAcesso = this.idGrupoAcesso;
          novoUsuarioFuncionalidade.idCliente = parseInt(this._cookieService.get('idCliente'), 10);

          for (const usuarioFuncionalidade of usuariosFuncionalidade) {
            if (usuarioFuncionalidade.usuario.idUsuario === usuario.idUsuario) {
              novoUsuarioFuncionalidade.idUsuarioFuncionalidade = usuarioFuncionalidade.idUsuarioFuncionalidade;
              novoUsuarioFuncionalidade.selecionado = true;
              break;
            }
          }
          this.usuariosFuncionalidade.push(novoUsuarioFuncionalidade);
        }
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeUsuarioBind = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }

  selecionar(usuarioFuncionalidade: UsuarioFuncionalidade, event): void {
    usuarioFuncionalidade.selecionado = !usuarioFuncionalidade.selecionado;
    usuarioFuncionalidade.alterado = true;
  }

  selecionarTodos(): void {
    this.selecionados = !this.selecionados;
    this.usuariosFuncionalidade.forEach(usuarioFuncionalidade => {
      usuarioFuncionalidade.selecionado = this.selecionados;
      usuarioFuncionalidade.alterado = true;
    });
  }

  emit(): void {
    this.loading = true;
    const usuariosFuncionalidadeInsert = new Array<UsuarioFuncionalidade>();
    const usuariosFuncionalidadeRemove = new Array<UsuarioFuncionalidade>();
    this.usuariosFuncionalidade.forEach(usuarioFuncionalidade => {
      if (!usuarioFuncionalidade.selecionado && usuarioFuncionalidade.idUsuarioFuncionalidade !== undefined
        && usuarioFuncionalidade.alterado) {
        usuariosFuncionalidadeRemove.push(usuarioFuncionalidade);
      } else if (usuarioFuncionalidade.selecionado && usuarioFuncionalidade.idUsuarioFuncionalidade === undefined
        && usuarioFuncionalidade.alterado) {
        usuariosFuncionalidadeInsert.push(usuarioFuncionalidade);
      }
    });
    if (usuariosFuncionalidadeRemove.length > 0) {
      this._permissoesAcessoService.removerUsuariosFuncionalidadeHttp(usuariosFuncionalidadeRemove)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.usuarioFuncionalidadeEvent.emit(this.usuariosFuncionalidade);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    if (usuariosFuncionalidadeInsert.length > 0) {
      this._permissoesAcessoService.cadastrarUsuariosFuncionalidadeHttp(usuariosFuncionalidadeInsert)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.usuarioFuncionalidadeEvent.emit(this.usuariosFuncionalidade);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    this.loading = false;
    this.usuarioFuncionalidadeEvent.emit(this.usuariosFuncionalidade);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/listar-usuarios-filtro-funcionalidade/listar-usuarios-filtro-funcionalidade.component.ts